import { Company } from 'lib-shared-types-api';
import { connect } from 'react-redux';

import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { notificationActions } from '../../../notifications/actions/notification';
import { actions } from '../actions/companyModal';
import CompanyModal from '../components/CompanyModal';

const { notificationAdd } = notificationActions;

const mapStateToProps = (state: any) => {
  const initialValues = Object.assign({}, state.companyModal.company);

  initialValues.name =
    typeof initialValues.display_name === 'string'
      ? initialValues.display_name
      : initialValues.name;

  return {
    initialValues: initialValues,
    meta: state.companyModal.meta,
    ui: state.companyModal.ui,
    companyId: state.companyModal.companyId,
    users: state.companyModal.users,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    addCompany: bindActionToPromise(dispatch, actions.companyModalAddCompany),
    editCompany: bindActionToPromise(
      dispatch,
      actions.companyModalUpdateCompany,
    ),

    getPresigned: (file: string, companyId: string) => {
      dispatch(
        actions.companyModalGetPresignedUrl({
          file: file,
          companyId: companyId,
        }),
      );
    },

    updateAvatar: (file: string, company: Company) => {
      dispatch(actions.companyModalUpdateAvatar(file, company));
    },

    getRelatedUsers: (companyId: string) =>
      dispatch(actions.companyModalGetUsers(companyId)),

    openAvatarCropperFileChange: (imageURI: string) =>
      dispatch(actions.companyModalOpenAvatarCropperFileChange(imageURI)),

    closeAvatarCropper: () => {
      dispatch(actions.companyModalCloseAvatarCropper());
    },

    avatarImageHandleCrop: (imageURI: string) =>
      dispatch(actions.avatarImageHandleCrop(imageURI)),

    hideModal: () => dispatch(actions.companyModalHidden()),

    notificationAdd: (payload: any) => dispatch(notificationAdd(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyModal);
